import { useLocation, Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { api, errMsg } from "@/lib/api";
import { MailCheck, FlaskConical } from "lucide-react";

export default function CheckEmailPage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const email = state?.email;
  const devVerifyUrl = state?.devVerifyUrl;

  const resend = async () => {
    if (!email) return;
    try {
      const res = await api.post("/auth/resend-verification", { email });
      toast.success(res.data.message);
      if (res.data.dev_verify_url) {
        navigate("/check-email", { state: { email, devVerifyUrl: res.data.dev_verify_url }, replace: true });
      }
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <AuthLayout>
      <Card className="border shadow-none">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-[hsl(var(--status-ok)/0.12)]">
            <MailCheck className="h-6 w-6 text-[hsl(var(--status-ok))]" />
          </div>
          <h1 className="text-xl font-semibold">Check your inbox</h1>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
            We sent a verification link to{" "}
            <span className="font-medium text-foreground">{email || "your email"}</span>.
            Click it to activate your account — the link is valid for 24 hours.
          </p>
          <div className="mt-6 space-y-3">
            <Button variant="secondary" className="w-full rounded-xl" onClick={resend} data-testid="check-email-resend-button">
              Resend the link
            </Button>
            {devVerifyUrl && (
              <a href={devVerifyUrl} className="block" data-testid="check-email-dev-verify-link">
                <Button variant="outline" className="w-full rounded-xl gap-2">
                  <FlaskConical className="h-4 w-4" />
                  Open verification link (dev shortcut)
                </Button>
              </a>
            )}
          </div>
          <p className="mt-6 text-sm text-muted-foreground">
            Verified already?{" "}
            <Link to="/login" className="font-medium text-foreground underline underline-offset-4" data-testid="check-email-login-link">
              Log in
            </Link>
          </p>
        </CardContent>
      </Card>
    </AuthLayout>
  );
}
